/* global Swiper, attachEvent */
// **********************************************************
// Hero slider
// **********************************************************

const seasonNavLink = document.querySelectorAll('.season__nav-link');
const seasonSliderElements = document.querySelectorAll('[data-slider="season-slider"]');
const seasonSliderOptions = {
  effect: 'fade',
  loop: false,
  fadeEffect: {
    crossFade: true,
  },
};

const changeSeasonsColor = () => {
  const parent = document.querySelector('.sc-season--no-overlay');
  if (parent) {
    const activeSlide = parent.querySelector('.season__slider .swiper-slide.swiper-slide-active');
    const slideDark = activeSlide.classList.contains('season__slide--dark-text');
    parent.classList.toggle('sc-season--dark', slideDark);
  }
};

seasonSliderElements.forEach((el) => {
  const seasonSlider = new Swiper(el, seasonSliderOptions);

  seasonSlider.on('slideChange', () => {
    const activeSlideIndex = seasonSlider.activeIndex;
    const allSeasonNavLinks = document.querySelectorAll('.season__nav-link');
    const seasonNavLinks = document.querySelectorAll('.season__nav-link')[activeSlideIndex];
    const activeIndicator = document.querySelector('.season__nav-active-indicator');

    allSeasonNavLinks.forEach((allSeasonNavLink) => {
      allSeasonNavLink.classList.remove('is-active');
    });

    seasonNavLinks.classList.add('is-active');

    activeIndicator.style.transform = `translateX(${seasonNavLinks.offsetLeft}px)`;
  });

  attachEvent('.season__nav-link', 'click', (ev) => {
    const parentElem = ev.target.closest('.season');
    const targetSlide = ev.target.getAttribute('data-slide');
    const activeIndicator = parentElem.querySelector('.season__nav-active-indicator');

    seasonNavLink.forEach((elm) => {
      elm.classList.remove('is-active');
    });
    ev.target.classList.add('is-active');
    seasonSlider.slideTo(targetSlide, 300);
    activeIndicator.style.transform = `translateX(${ev.target.offsetLeft}px)`;
  });

  changeSeasonsColor();
  seasonSlider.on('slideChangeTransitionStart', () => changeSeasonsColor());
});
